import { Injectable } from '@angular/core';
import { State, Action, StateContext, Selector } from '@ngxs/store';
import { SetActiveRoute, ToogleModalQrCode } from './config.actions';

export class IConfigModel {
  showModalQrCode: boolean;
  activeRoute: string;
}

@State<IConfigModel>({
  name: 'config',
  defaults: {
    showModalQrCode: false,
    activeRoute: '',
  },
})
@Injectable()
export class ConfigState {
  @Selector()
  static activeRoute(state: IConfigModel) {
    return state.activeRoute;
  }

  @Action(ToogleModalQrCode)
  toogleModalQrCode({ getState, setState }: StateContext<IConfigModel>) {
    const state = getState();
    setState({
      ...state,
      showModalQrCode: !state.showModalQrCode,
    });
  }

  @Action(SetActiveRoute)
  updateActiveRoute({ getState, setState }: StateContext<IConfigModel>, { route }: SetActiveRoute) {
    const state = getState();
    setState({
      ...state,
      activeRoute: route,
    });
  }
}
